import React, { useState, useEffect } from "react";
import { fetchSettings } from "../utils/settingsApi";
import MetroBIcon from "../assets/icons/Metropolitana_di_Roma_-_logo_linea_B.svg";
import WalkingIcon from "../assets/icons/walking-person-go-walk-move.svg";

export default function Footer() {
  const [settings, setSettings] = useState(null);
  const [mapHovered, setMapHovered] = useState(false);

  useEffect(() => {
    fetchSettings().then(data => setSettings(data));
  }, []);

  const addresses = settings?.addresses ? settings.addresses.split('\n') : [];
  const emails = settings?.emails ? settings.emails.split('\n') : [];
  const phones = settings?.phones ? settings.phones.split('\n') : [];
  return (
    <>
      <div className="container-fluid pt-5 mt-5 px-sm-3 px-md-5">
        <div className="text-center pb-2">
          <p className="section-title px-5">
            <span className="px-2">Our Location</span>
          </p>
          <h1 className="mb-4">Visit Our School</h1>
          <p className="mb-4" style={{ fontSize: '1.15rem', color: '#555', fontWeight: 500 }}>
            Only 400m (8 minutes
            <img
              src={WalkingIcon}
              alt="walk"
              style={{ height: '18px', margin: '0 4px', marginTop: '-3px' }}
            />) from Ponte Mammolo
            <img
              src={MetroBIcon}
              alt="Metro B"
              style={{ height: '22px', marginLeft: '8px', marginTop: '-4px' }}
            />
          </p>
        </div>
        <a
          href="https://www.google.com/maps/dir/?api=1&destination=VIALE+PALMIRO+TOGLIATTI+1587,+ROME+-+00155"
          target="_blank"
          rel="noopener noreferrer"
          className="d-block position-relative overflow-hidden"
          style={{
            height: '450px',
            borderRadius: '20px',
            boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
            textDecoration: 'none',
            border: '8px solid white',
            transform: mapHovered ? 'scale(1.01)' : 'scale(1)',
            transition: 'transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)'
          }}
          onMouseEnter={() => setMapHovered(true)}
          onMouseLeave={() => setMapHovered(false)}
        >
          {/* Glassmorphism Floating Card */}
          <div
            className="position-absolute d-flex flex-column p-4"
            style={{
              bottom: '30px',
              left: '30px',
              background: 'rgba(255, 255, 255, 0.9)',
              backdropFilter: 'blur(10px)',
              WebkitBackdropFilter: 'blur(10px)',
              zIndex: 2,
              borderRadius: '16px',
              maxWidth: '350px',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.15)',
              border: '1px solid rgba(255, 255, 255, 0.6)',
              transition: 'all 0.3s ease',
              transform: mapHovered ? 'translateY(-5px)' : 'translateY(0)'
            }}
          >
            <h4 className="text-primary font-weight-bold mb-2 d-flex align-items-center">
              <div
                className="bg-primary text-white d-flex align-items-center justify-content-center rounded-circle mr-3"
                style={{ width: '40px', height: '40px' }}
              >
                <i className="fa fa-map-marker-alt"></i>
              </div>
              Our Campus
            </h4>
            <p className="text-dark mb-3" style={{ fontSize: '1.05rem', fontWeight: 500, lineHeight: '1.5' }}>
              VIALE PALMIRO TOGLIATTI 1587,<br />ROME - 00155
            </p>
            <div
              className="btn btn-primary text-white font-weight-bold py-2 px-4 rounded-pill d-inline-flex align-items-center justify-content-center"
              style={{ transition: 'all 0.3s ease', boxShadow: mapHovered ? '0 8px 20px rgba(23, 162, 184, 0.4)' : 'none' }}
            >
              <span>Get Directions</span>
              <i className="fa fa-arrow-right ml-2" style={{ transform: mapHovered ? 'translateX(5px)' : 'none', transition: 'transform 0.3s ease' }}></i>
            </div>
          </div>
          <iframe
            title="School Location Map"
            src="https://maps.google.com/maps?q=VIALE%20PALMIRO%20TOGLIATTI%201587%2C%20ROME%20-%2000155&t=&z=14&ie=UTF8&iwloc=&output=embed"
            width="100%"
            height="100%"
            style={{ border: 0, pointerEvents: 'none', position: 'absolute', top: 0, left: 0, zIndex: 1, filter: 'contrast(1.1) brightness(1.05)' }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </a>
      </div>

      <div className="footerContainer">
        <div className="container-fluid bg-primary text-white mt-5 py-5 px-sm-3 px-md-5">
          <div className="row pt-5">
            <div className="col-lg-3 col-md-6 mb-5">
              <a
                href="/"
                className="navbar-brand font-weight-bold text-primary m-0 mb-4 p-0"
              >
                <img
                  style={{
                    height: "200px",
                    maxWidth: "100%",
                  }}
                  src={require("../assets/logo.png")}
                  alt=""
                />
              </a>
              <p>
                We rest on the transformational belief that we all learn better
                when we learn together. We challenge and support each student in
                his or her academic, social, and emotional growth.
              </p>
              <div className="d-flex justify-content-start mt-4">
                {settings?.facebook && (
                  <a className="btn btn-outline-white rounded-circle text-center mr-2 px-0" style={{ width: 38, height: 38 }} href={settings.facebook}>
                    <i className="fab fa-facebook-f" />
                  </a>
                )}
                {settings?.linkedin && (
                  <a className="btn btn-outline-white rounded-circle text-center mr-2 px-0" style={{ width: 38, height: 38 }} href={settings.linkedin}>
                    <i className="fab fa-linkedin-in" />
                  </a>
                )}
                {settings?.instagram && (
                  <a className="btn btn-outline-white rounded-circle text-center mr-2 px-0" style={{ width: 38, height: 38 }} href={settings.instagram}>
                    <i className="fab fa-instagram" />
                  </a>
                )}
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-5">
              <h3 className="text-white mb-4">Get In Touch</h3>
              <div className="d-flex mb-3">
                <i className="fa fa-map-marker-alt text-white" style={{ fontSize: '1.5rem' }} />
                <div className="pl-3">
                  <h5 className="text-white">Address</h5>
                  <div style={{ marginLeft: "0.5rem" }}>
                    {addresses.map((address, idx) => {
                      if (address.includes("(Metro M B)")) {
                        return (
                          <p key={idx} style={{ marginBottom: "0.275rem" }}>
                            {address.replace("(Metro M B)", "")}
                            <img
                              src={MetroBIcon}
                              alt="Metro B"
                              style={{ height: '20px', marginLeft: '5px', marginTop: '-3px' }}
                            />
                          </p>
                        );
                      }
                      return <p key={idx} style={{ marginBottom: "0.275rem" }}>{address}</p>;
                    })}
                  </div>
                </div>
              </div>
              <div className="d-flex mb-3">
                <i className="fa fa-envelope text-white" style={{ fontSize: '1.5rem' }} />
                <div className="pl-3">
                  <h5 className="text-white">Email</h5>
                  <div style={{ marginLeft: "0.275rem" }}>
                    {emails.map((email, idx) => (
                      <p key={idx} style={{ marginBottom: "0.175rem" }}>{email}</p>
                    ))}
                  </div>
                </div>
              </div>
              <div className="d-flex">
                <i className="fa fa-phone-alt text-white" style={{ fontSize: '1.5rem' }} />
                <div className="pl-3">
                  <h5 className="text-white">Phone</h5>
                  <div style={{ marginLeft: "0.275rem" }}>
                    {phones.map((phone, idx) => (
                      <p key={idx} style={{ marginBottom: "0.175rem" }}>{phone}</p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-5">
              <h3 className="text-white mb-4">Quick Links</h3>
              <div className="d-flex flex-column justify-content-start">
                <a className="text-white mb-2" href="/">
                  <i className="fa fa-angle-right mr-2" />
                  Home
                </a>
                <a className="text-white mb-2" href="/about">
                  <i className="fa fa-angle-right mr-2" />
                  About Us
                </a>
                <a className="text-white mb-2" href="/classes">
                  <i className="fa fa-angle-right mr-2" />
                  Our Classes
                </a>
                <a className="text-white mb-2" href="/academics">
                  <i className="fa fa-angle-right mr-2" />
                  Our Teachers
                </a>
                <a className="text-white" href="/contact">
                  <i className="fa fa-angle-right mr-2" />
                  Contact Us
                </a>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-5">
              <h3 className="text-white mb-4">Email Us</h3>
              <form action="">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control border-0 py-4"
                    placeholder="Your Name"
                    required="required"
                  />
                </div>
                <div className="form-group">
                  <input
                    type="email"
                    className="form-control border-0 py-4"
                    placeholder="Your Email"
                    required="required"
                  />
                </div>
                <div style={{ marginTop: "1.5rem" }}>
                  <button
                    className="btn btn-secondary btn-block border-0 py-3"
                    type="submit"
                  >
                    Submit Now
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div
            className="container-fluid pt-5"
            style={{ borderTop: "1px solid rgba(23, 162, 184, .2)" }}
          >
            <p className="m-0 text-center text-white">
              ©{" "}
              <a className="text-white font-weight-bold" href="/">
                EUISC
              </a>
              . All Rights Reserved. Designed by
              <a
                className="text-white font-weight-bold"
                href="https://asyncus.com"
              >
                {" ASYNCUS"}
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
